/* =============================================================================
   VIEA CART UPSELL + Dr Free Gift refresh | BY CLICKMOUSE
   -----------------------------------------------------------------------------
   Horizon 4.x-native rebuild. The upsell card is server-rendered by
   snippets/cart-upsell-block.liquid (via cart-summary.liquid) and re-renders with
   the cart section on every morph, so there is NO DOM injection and NO cart-event
   listener here. This file does two things only:

     1. Handle the ADD click (delegated on document, so it survives every morph).
     2. Expose window.refreshCart for Dr Free Gift's no-reload hook.

   Both call one helper that asks Horizon 4.x to re-render the cart from the server.

   Replaces the retired pre-4.x scripts:
     - viea-cart-upsell-widget.js (client-side widget injection)
     - viea-cart-upsell-lock.js  (client-side remove-button lock)
   The remove-button lock is now server-rendered in snippets/cart-products.liquid,
   and the upsell-only checkout guard is server-rendered in snippets/cart-summary.liquid.
   ============================================================================= */

(function () {
  // --- 4.x cart refresh: dispatch shopify:cart:lines-update with a resolved .promise.
  //     With no sections attached, cart-items-component refetches from the server and
  //     morphs the whole cart section (drawer + page). Nothing JS-injected to wipe.
  function triggerCartRefresh() {
    const cartLinesUpdate = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    cartLinesUpdate.promise = Promise.resolve({ detail: {} });
    document.dispatchEvent(cartLinesUpdate);
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); // legacy, harmless
  }

  // Dr Free Gift calls this instead of reloading after awarding a gift.
  window.refreshCart = triggerCartRefresh;

  // --- Delegated ADD handler: survives every cart morph.
  document.addEventListener('click', async function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const btn = target && target.closest('.viea-cart-upsell-widget__add-btn');
    if (!btn) return;
    event.preventDefault();

    const variantId = btn.getAttribute('data-upsell-variant');
    if (!variantId || btn.hasAttribute('disabled')) return;

    const originalLabel = btn.textContent;
    btn.setAttribute('disabled', '');
    btn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('cart/add failed: ' + response.status);
      triggerCartRefresh();
    } catch (error) {
      console.error('VIEA Cart Upsell: failed to add product', error);
      btn.textContent = originalLabel;
      btn.removeAttribute('disabled');
    }
  });
})();